import React from "react";
import {StudyLinks} from "../../gen/api";
import LinksEdit from "../LinksEdit/LinksEdit";

type Props = {
  studyLinks: StudyLinks[]

    handleNewStudySubmit: (studyLink: StudyLinks) => void
    handleDeleteStudyLink: (studyLink: StudyLinks) => void
}

function StudyLinksEdit({
                            studyLinks,
                            handleNewStudySubmit,
                            handleDeleteStudyLink
                      }: Props) {

  return (
      <>
          <LinksEdit links={studyLinks} handleNewLinkSubmit={handleNewStudySubmit} handleDeleteLink={handleDeleteStudyLink}></LinksEdit>
      </>
  );
}

export default StudyLinksEdit;